import(/* webpackMode: "eager" */ "/home/runner/work/linqops/linqops/apps/adminApp/app/site-terms/page.tsx");
